import Header from '../components/Header'
import Footer from '../components/Footer'
import ConfigWizard from '../components/ConfigWizard'

export default function ConfigurePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <section className="section bg-gradient-to-br from-gray-50 to-gray-100 flex-1">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Configure Your Chatbot
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Answer a few questions to customize your AI chatbot. Takes about 2 minutes.
            </p>
          </div>

          <ConfigWizard />
        </div>
      </section>

      <Footer />
    </div>
  )
}
